import React from 'react';
import './panelists.scss';

function Panelist({ data }) {
  const { photo, name, caption } = data;
  return (
    <figure className="panelists__item__panelist">
      <img alt={`Headshot of ${name}`} src={photo}></img>
      <figcaption>
        <div className="panelists__item__panelist__name">{name}</div>
        <p> {caption}</p>
      </figcaption>
    </figure>
  );
}

export default Panelist;
